import BorderButton from '@/Component/Common/Forms/BorderButton';
import PrimaryButton from '@/Component/Common/Forms/PrimaryButton';
import Image from 'next/image';
import { useRouter } from 'next/navigation';

const AppliedSuccessfully = (props) => {
    const { setModal, setOpenSideModal, setActiveTab, campaignInfluencers, translations, setParams, params, onCloseSidebar } = props;
    const router = useRouter();

    const handleClick = () => {
        setActiveTab && setActiveTab("applied");
        setParams && setParams({ ...params, page: 1, status: "applied" });
        setModal(false);
        setOpenSideModal(null);
        // Clear URL slug / deep-link state so campaign-brand is not called with campaign_id=undefined
        onCloseSidebar?.();
        router.push('/influencer/jobs?tab=applied');
    }


    const handleDiscover = () => {
        setActiveTab && setActiveTab("all")
        setParams && setParams({ ...params, page: 1, status: "all" });
        setModal(false);
        setOpenSideModal(null);
        onCloseSidebar?.();
        router.push('/influencer/jobs?tab=all');
    }

    const afterQuoteStatus = {
        "drafting_deliverables": true,
        "draft_available": true,
        "posting_deliverables": true,
        "completion_request": true
    }

    return (
        <div className='flex items-center flex-col justify-center py-20 px-5 text-center'>
            <Image src={'/assets/images/approval-check.png'} width={100} height={100} alt="checkmark" />
            <h3 className='mt-7 mb-3 text-3xl font-semibold'>{translations?.application} {campaignInfluencers?.[0]?.status == "quotation_available" || afterQuoteStatus[campaignInfluencers?.[0]?.status] ? translations?.updated : translations?.submitted} {translations?.successfully}</h3>
            <p className='text-center text-xl text-tertiary'>
                {translations?.applicationSubmittedSuccessfully} <br />{translations?.applicationSubmittedSuccessfully2} </p>
            <div className='flex justify-center gap-4 mt-10 flex-wrap'>
                <BorderButton onClick={handleClick} title={translations?.viewAppliedJobs} customClass="min-w-52" />
                <PrimaryButton onClick={handleDiscover} title={translations?.discoverMoreJobs} customClass="min-w-52" />
            </div>
        </div>
    )
}

export default AppliedSuccessfully
